import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'filterBrands',
  standalone: true,
})
export class FilterBrandsPipe implements PipeTransform {
  transform(brands: Array<any>, firstLetter?: string) {
    if (firstLetter === 'all') {
      return brands;
    } else {
      return brands?.filter((brand) => brand.BrandName.charAt(0).toLowerCase() === firstLetter?.toLowerCase());
    }
  }
}
